<div class="auctions-page-layout">
  <app-page-header
    [title]="'auction.previous_auctions' | translate"
    [imgPath]="
      '../../../../../../../assets/images/baners/bg-header-buyer-account.webp'
    "
    [breadcrumbs]="breadcrumbs"
    >
  </app-page-header>
  <div class="container auctions-container">
    <!-- <div class="auctions-header">
    <h1 class="title-primary">Previous Auctions</h1>

  </div> -->
  <!-- <div class="search-container">

  <search-input
    (searchChanged)="handleSearch($event)"
  ></search-input>
</div> -->

<app-buyer-page-options>
  <div class="col-lg-4 col-md-12 col-sm-12">
    <search-input
      search
      [inputPlaceholder]="'auction.search_auction_name' | translate"
      (searchChanged)="handleSearch($event)"
      [(search)]="searchVal"
      (searchEmpty)="resetSearch()"
      [isLoading]="isLoading"
      data-translation-key="auction_search_auction_name"
    ></search-input>
  </div>
  <div
    class="col-lg-6 col-md-12 col-sm-12 filter-container__sorting bb-0 my-md-4 mt-4 justify-content-lg-end justify-content-between"
    [hidden]="auctions.length == 0 || isLoading"
    >
    <app-pagination-results
      [paginationData]="paginationData"
    ></app-pagination-results>

    <select
      hidden
      class="sorting-select"
      aria-label="Sorting Select"
      aria-describedby="Language Select"
      >
      <option selected disabled>Default sorting</option>
      <option>
        <span>Asc</span>
      </option>
      <option>
        <span>Desc</span>
      </option>
    </select>
  </div>
</app-buyer-page-options>

<div class="auctions-cards row">
  @for (item of auctions; track item) {
    <div
      class="col-lg-4 col-md-6 col-sm-12 mb-3"
      (click)="cardClicked($event, item)"
      >
      <app-buyer-auction-card
        [auction]="item"
        [loggedIn]="loggedIn"
        [auctionType]="auctionType"
        [darkTimer]="true"
        >
      </app-buyer-auction-card>
    </div>
  }
</div>
@if (isLoading) {
  <div class="loading">
    <div class="donut"></div>
  </div>
}
@if (!isLoading && auctions.length == 0) {
  <div>
    <app-no-data
      [showImg]="false"
        [message]="{
          message: 'auction.no_data_available' | translate,
          translationsKey: 'auction_no_data_available'
        }"
      [subMessage]="{ subMessage: '', translationsKey: '' }"
      >
    </app-no-data>
  </div>
}
@if (!isLoading) {
  <div>
    <app-pagination
      [currentPage]="page || 1"
      [totalPages]="paginationData?.totalPages"
      (pageChanged)="onPageChanged($event)"
      >
    </app-pagination>
  </div>
}
</div>
</div>
